<template>
    <v-col cols="12" class="py-0">
        <v-tabs-items v-model="tab">
            <v-tab-item v-for="item in items" :key="item.name">
                <component :is="item.name"></component>
                <dms-roles-form-actions></dms-roles-form-actions>
                <!-- <patient-form-actions v-if="item.hasActions"></patient-form-actions> -->
            </v-tab-item>
        </v-tabs-items>
    </v-col>
</template>

<script>
export default {
    data() {
        return {
            items: [
                { name: 'dms-roles-details', hasActions: false },
                { name: 'dms-roles-permissions', hasActions: false },
            ],
        };
    },
    computed: {
        tab: {
            get() {
                return this.$store.state.dms_roles.tab;
            },
            set(value) {
                this.$store.dispatch('dms_roles/changeTab', value);
            },
        },
    },
};
</script>

<style></style>
